import { Avatar as AvatarOG } from "@mui/material";
import type { ComponentPropsWithoutRef } from "react";

interface AvatarProps extends ComponentPropsWithoutRef<"div"> {
    size: number;
    alt?: string;
    imageUrl?: string;
}

// Alt is Babel Cast to have show "BC" as initials
export default function Avatar({ size, alt ="Babel Cast", imageUrl, ...rest }: AvatarProps) {
    const avatarProps = {
        sx: { width: size, height: size },
        alt,
        src: imageUrl ? imageUrl : undefined,
        ...rest,
    };

    if(!imageUrl && alt) {
        const initials = getFirstAndLastInitials(alt)

        return <AvatarOG {...avatarProps}>{initials}</AvatarOG>;
    }

    return <AvatarOG {...avatarProps} />;
}

function getFirstAndLastInitials(name: string) {
    if (!name) return "";

    const initialsArray = name
        .split(" ")
        .map((part) => (part[0] || "").toUpperCase());
    const firstInitial = initialsArray[0];
    const lastInitial = initialsArray[initialsArray.length - 1];

    return initialsArray.length > 1
        ? `${firstInitial}${lastInitial}`
        : firstInitial;
}